<!-- <div class="w3-card-4" style="width:50%;">
  <div class="w3-container w3-blue">
    <h1>{{name}}</h1>
</div>

  <div class="w3-container">
    <p>Lorem ipsum </p>
  </div>

</div>
 -->

<div class="text-card" *ngIf="zoneData" [id]="zoneData.id" #rootZone>
  <span class="componentCount" [id]="zoneData.id">
    <i class="" [id]="zoneData.id">{{zoneData.elements.length}}/{{zoneData.limit}}</i>
  </span>
  <div [class]="zoneData.elements.length ? 'posTopMiddle heading' : 'posMiddle heading'" [id]="zoneData.id">
    <h1 [id]="zoneData.id">{{zoneData.name}}</h1>
  </div>
  <ng-container *ngFor="let collection of zoneData.elements">
    <div class="text-box handle sortpara" *ngIf="collectionData.hasOwnProperty(collection)"
      [id]="zoneData.id + '|' + collectionData[collection].id"   (dragstart)="dragStart($event)" draggable="true">
      {{collectionData[collection].title}}
      <div class="settingTemp">
        <span [id]="zoneData.id + '|' + collectionData[collection].id"><i class="icon-move"></i></span>
        <!-- <span class="editBtn" (click)="openElementMeta(collection)"
          [id]="zoneData.id + '|' + collectionData[collection].id"><i class="icon-articles"></i></span> -->

        <span *ngIf="collectionData[collection].type !== 'cricket'" class="editBtn" (click)="openCollection(collection)"
          [id]="zoneData.id + '|' + collectionData[collection].id"><i class="icon-pickup"></i></span>
        <span class="deleteHeadline" (click)="deleteCollection(collection)"
          [id]="zoneData.id + '|' + collectionData[collection].id"><i class="icon-delete"></i></span>
      </div>
    </div>
  </ng-container>
  <div class="settingTemp">

    <span class="editBtn" (click)="openPopup()"><i class="icon-pickup"></i></span>
    <span class="deleteHeadline" (click)="clearCollections()">
      <i class="icon-delete"></i>
    </span>

  </div>


  <div [class]="editCollection ? 'lightBox componentListPop block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePopup()"></div>
    </div>
    <div class="app-zone-listing" *ngIf="editCollection" [collectionList]="zoneData.elements" [limit]="zoneData.limit"
      (selectionCompleted)="setCollections($event)" (closeSelection)="closePopup()"
      [elementsToExclude]="elementsToExclude"></div>
  </div>

  <div *ngIf="metaPopup && previewMetaData !== null"
    [class]="metaPopup ? 'lightBox metaPopup block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeElementMeta()"></div>
    </div>
    <div class="lightContent">
      <div class="metaTemplate">
        <h3>Metadata of {{collectionData[idForMeta].title}}</h3>
        <ul>
          <li>
            <label>Design</label>
        <div class="dataField">
          <select [(ngModel)]="previewMetaData.design" [compareWith]="compareFn">
            <ng-container *ngFor="let c of componentDesigns">
              <option [selected]="previewMetaData.design == c" [ngValue]="c">{{c}}</option>
            </ng-container>
          </select>
        </div>
      </li>
      <li>
        <label>Limit</label>
            <div class="dataField">
              <input type="number" [(ngModel)]="previewMetaData.limit">
            </div>
          </li>
<li>
    <label>Page Type</label>
        <div class="dataField">
          <select [(ngModel)]="optionOfMeta" (ngModelChange)="onChange($event)" [compareWith]="compareFn">
            <ng-container *ngFor="let c of metaOptions">
              <option [selected]="optionOfMeta == c" [ngValue]="c">{{c}}</option>
            </ng-container>
          </select>
        </div>
      </li>
      <li>
          <label>Page Name</label>
        <div class="dataField relative">
          <input [formControl]='metaQuery' #pageField class="search-components textBox" type="text" [(ngModel)]="str"
          (keyup)="filterAutoCompleteUp($event ,'page')" (keydown)="filterAutoCompleteDown($event ,'page')"
          (focus)="focusInSuggest('page')"  (focusout)="false">
          <!-- <ng-container *ngIf="insidePage"> -->
          <div #pageList class="autosuggestion block" *ngIf="insidePageField && listArray && listArray.length > 0">
              <ul *ngFor="let item of listArray; let i = index">
                <li (click)="selectAutoComplete('page', item)" [class.active]="i === currentSelection">
                  <span class="name">{{item.name}}</span>
                </li>
              </ul>
            </div>
            <ng-container *ngIf="insidePageField && (1 > listArray.length)">
              <div class="autosuggestion block">
                <ul>
                  <li>
                    <span class="name">No Results</span>
                  </li>
                </ul>
              </div>
            </ng-container>
            <!-- </ng-container> -->
        </div>
      </li>
      </ul>
    </div>

      <div class="fr wid100 right">
        <button type="button" name="cancel" (click)="closeElementMeta()" class="cancel gray mtb15 ml10">Cancel</button>
        <button type="button" name="add" (click)="saveElementMeta()" class="add blue mtb15 ml10 mr30">Save</button>
      </div>

    </div>
  </div>
</div>
